import { EventUserType } from 'types/enums';
import { IconmoonFont } from 'vibo-ui/Icon';

export const USER_ROLE_BADGES = {
  [EventUserType.dj]: IconmoonFont['djCircle-16'],
  [EventUserType.host]: IconmoonFont['hostCircle-16'],
  [EventUserType.guest]: IconmoonFont['guestCircle-16'],
};
